import MarketingNav from "@/components/marketing/MarketingNav";
import MarketingFooter from "@/components/marketing/MarketingFooter";

/**
 * Wraps a marketing page with the shared chrome:
 *   - <MarketingNav /> (sticky top nav)
 *   - <main>{children}</main>
 *   - <MarketingFooter />
 *
 * Usage:
 *   <MarketingLayout>
 *     ...page content...
 *   </MarketingLayout>
 */
export default function MarketingLayout({ children }) {
  return (
    <>
      <MarketingNav />
      <main>{children}</main>
      <MarketingFooter />
    </>
  );
}
